/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { COVERAGE_OPTIONS, type Coverage } from "../api/careTeam";
import { ToggleButton } from "./ui/ToggleButton";

const COVERAGE_HINTS: Record<Coverage, string> = {
  SUPPORT: "Answers family messages. Never the family's lead coordinator.",
  PRIMARY: "Can be the family's lead coordinator for escalations and billing.",
};

/** Picks a coordinator's coverage and says what the choice means for the family. */
export function CoverageChoice({
  value,
  onChange,
}: {
  value: Coverage;
  onChange: (coverage: Coverage) => void;
}) {
  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-text-secondary">Coverage</p>
      <ToggleButton
        ariaLabel="Coverage"
        options={COVERAGE_OPTIONS}
        value={value}
        onChange={(choice) => onChange(choice as Coverage)}
      />
      <p className="text-xs text-text-tertiary">{COVERAGE_HINTS[value]}</p>
    </div>
  );
}
